import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

/**
 * 客户信息反馈（工单）分页列表
 * 接口：GET /joins-sales-cloud/v1/ticket/page
 * 实测可用路径（无 manage 前缀，与首次成功返回一致；manage 路径当前后端不通/返回空）
 * 分页结构：{ records, total }
 * 请求参数（Query）：
 *   status    状态筛选 pending/processing/resolved/closed
 *   keyword   关键字模糊搜索（称呼/电话/问题详情）
 *   startTime 创建时间起（毫秒）
 *   endTime   创建时间止（毫秒）
 *   page      页码，从 1 起，默认 1
 *   size      每页条数，默认 10
 */
export const findTicketPage = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/ticket/page?` + params,
        method: 'GET'
    });
}

/**
 * 编辑工单（状态 / 备注），合并接口
 * 接口：POST /joins-sales-cloud/v1/ticket/manage/edit
 * 请求体：{ id: number, status?: string, remark?: string }
 * status 与 remark 按传入字段更新，可只传其一、也可同时传；未传字段保持原值。
 * remark 整体覆盖式保存，传空字符串即清空。
 */
export const updateTicketEdit = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/ticket/manage/edit`,
        method: 'POST',
        data
    });
}
